import Axios from 'axios';

export default {
  loadDisallowedReasons() {
    return Axios.get('/admin/enums/contact-preferences/disallowed-reason');
  },
  openEnrollmentInterruptionSolicitation(contractPreferenceId, solicitationData) {
    return Axios.put(`/admin/contact-preferences/${contractPreferenceId}`, solicitationData).then(({ data }) => data);
  },
};
